import { render, staticRenderFns } from "./text-row-phone.vue?vue&type=template&id=3af01b4c&scoped=true&"
import script from "./text-row-phone.vue?vue&type=script&lang=js&"
export * from "./text-row-phone.vue?vue&type=script&lang=js&"
import style0 from "./text-row-phone.vue?vue&type=style&index=0&id=3af01b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af01b4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af01b4c')) {
      api.createRecord('3af01b4c', component.options)
    } else {
      api.reload('3af01b4c', component.options)
    }
    module.hot.accept("./text-row-phone.vue?vue&type=template&id=3af01b4c&scoped=true&", function () {
      api.rerender('3af01b4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/text-row-phone.vue"
export default component.exports